import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useUserContext } from '../../context/UserContext.tsx';

export default function StoresDropDown({ storeValue, setStoreValue, setStoreName, storename }) {
  const { user } = useUserContext()

  const handleChange = (event: SelectChangeEvent) => {
    setStoreValue(event.target.value as string);
    const selectedStoreId = event.target.value as string;
    const selectedStore = user?.stores.find(item => item?._id === selectedStoreId);
    // console.log(selectedStore)
    if (selectedStore) {
      setStoreValue(selectedStoreId);
      setStoreName(selectedStore?.name); // Assuming setStoreName is a function to update the store name
    }
    // if(event.target.value==="all"){
    //   setStoreValue(null);
    //   setStoreName('All Stores'); // Assuming setStoreName is a function to update the store name
    // }
  };

  return (
    <Box sx={{ width: "99%", marginTop: "10px", backgroundColor: "white" }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label"
        >{storename ? storename : "Select Store"}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={storeValue}
          label="Select Store"
          onChange={handleChange}
          sx={{ height: "44px" }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 200,
              },
            },
          }}
        >
          {/* <MenuItem value={'all'}>All stores</MenuItem> */}
          {
            user?.stores.map((item) => {
              return <MenuItem key={item?._id} id={item?._id} value={item?._id}>{`${item?.name}, ${item?.city}`}</MenuItem>
            })
          }
        </Select>
      </FormControl>
    </Box>
  );
}
